import { AbstractEntityMapper } from '@pf/shared-services';
import {
    ProjectLineItemCreate,
    ProjectLineItemDto,
    ProjectLineItemRead,
    ProjectLineItemSearchParams,
} from '../../entities/project-line-item.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { ProjectLineItemMetadataMap } from './project-line-item.mapping-profile';

@Injectable()
export class ProjectLineItemMapper extends AbstractEntityMapper<
    ProjectLineItemRead,
    ProjectLineItemCreate,
    ProjectLineItemDto,
    ProjectLineItemSearchParams
> {
    constructor() {
        super(
            ProjectLineItemDto,
            PlatformWmsMapper,
            ProjectLineItemMetadataMap.symbols
        );
    }
}
